import { supabase } from '@/integrations/supabase/client';

export type PublicUserV1 = {
  id: string;
  name: string;
  photo_urls: string[];
  profile_image_public_id: string | null;
  is_verified: boolean;
};

type PublicUserV1Row = {
  id: string;
  display_name: string | null;
  photo_urls: unknown;
  profile_image_public_id: string | null;
  is_verified: boolean | null;
};

const PUBLIC_USER_V1_SELECT =
  'id, display_name, photo_urls, profile_image_public_id, is_verified';

function normalizeRow(row: PublicUserV1Row): PublicUserV1 {
  return {
    id: row.id,
    name: row.display_name || 'Someone',
    photo_urls: Array.isArray(row.photo_urls) ? (row.photo_urls as string[]) : [],
    profile_image_public_id: row.profile_image_public_id ?? null,
    is_verified: row.is_verified === true,
  };
}

export async function getPublicUserV1ById(userId: string): Promise<PublicUserV1 | null> {
  if (!userId) return null;

  const { data, error } = await supabase
    .from('users_public_v1' as never)
    .select(PUBLIC_USER_V1_SELECT)
    .eq('id', userId)
    .maybeSingle();

  if (error || !data) return null;
  return normalizeRow(data as unknown as PublicUserV1Row);
}

export async function getPublicUserV1ByIds(userIds: string[]): Promise<PublicUserV1[]> {
  const uniqueIds = [...new Set(userIds.filter(Boolean))];
  if (uniqueIds.length === 0) return [];

  const { data, error } = await supabase
    .from('users_public_v1' as never)
    .select(PUBLIC_USER_V1_SELECT)
    .in('id', uniqueIds);

  if (error || !data) return [];
  return (data as unknown as PublicUserV1Row[]).map(normalizeRow);
}
